module.exports = __webpack_public_path__ + "img/Asset 1@2x.e777c781.png";